import script from "./psiGoodsInstoreOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./psiGoodsInstoreOrder.vue?vue&type=script&setup=true&lang=js"

import "./psiGoodsInstoreOrder.vue?vue&type=style&index=0&id=1b1d08a9&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1d08a9"]])

export default __exports__